
export default function Features() {
  const features = [
    {
      icon: 'ri-speed-line',
      title: '빠른 구현',
      description: '평균 2-4주 내에 AI 솔루션을 구축하고 배포하여 빠른 ROI를 실현합니다'
    },
    {
      icon: 'ri-shield-check-line',
      title: '보안 우선',
      description: '엔터프라이즈급 보안 표준을 준수하여 데이터를 안전하게 보호합니다'
    },
    {
      icon: 'ri-refresh-line',
      title: '지속적 최적화',
      description: 'AI 모델을 지속적으로 학습시키고 개선하여 성능을 향상시킵니다'
    },
    {
      icon: 'ri-team-line',
      title: '전문가 팀',
      description: 'AI, 머신러닝, 데이터 과학 분야의 전문가들이 프로젝트를 지원합니다'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '합리적 가격',
      description: '투명한 가격 정책과 유연한 계약 옵션으로 예산에 맞는 솔루션을 제공합니다'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 지원',
      description: '언제든지 문의할 수 있는 전담 지원팀이 항상 대기하고 있습니다'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-teal-50 rounded-full px-4 py-2 mb-4">
              <i className="ri-star-line text-teal-600"></i>
              <span className="text-teal-600 text-sm font-semibold">Why Choose Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Freeworkers를<br />선택해야 하는 이유
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              우리는 단순히 AI 솔루션을 제공하는 것이 아니라, 귀사의 비즈니스 파트너로서 성공을 함께 만들어갑니다. 검증된 기술력과 풍부한 경험으로 최상의 결과를 보장합니다.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center space-x-2 bg-teal-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap"
            >
              <span>지금 시작하기</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-teal-600 text-xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
